var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,15.9c0.9,0,1.8-0.4,2.5-1c0.7-0.6,1-1.5,1-2.4V5.4c0-0.9-0.4-1.8-1-2.4c-0.7-0.6-1.6-1-2.5-1H5.6 C4.6,2,3.7,2.3,3.1,3C2.4,3.6,2,4.5,2,5.4v7.1c0,0.9,0.4,1.8,1,2.4c0.7,0.6,1.6,1,2.5,1C5.6,15.9,12.5,15.9,12.5,15.9z M12.5,17.1 H5.6c-2.7,0-4.8-2.1-4.8-4.6V5.4c0-2.6,2.2-4.6,4.8-4.6h6.9c2.7,0,4.8,2.1,4.8,4.6v7.1C17.3,15,15.2,17.1,12.5,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,6c-1.7,0-3,1.3-3,2.9c0,1.6,1.3,2.9,3,2.9c1.7,0,3-1.3,3-2.9S10.7,6,9,6 M13.6,8.9c0,2.4-2,4.4-4.6,4.4 c-2.5,0-4.6-2-4.6-4.4c0-2.4,2-4.4,4.6-4.4C11.6,4.5,13.6,6.4,13.6,8.9 M14.8,4.4c0,0.6-0.5,1-1.1,1c-0.6,0-1.1-0.5-1.1-1 s0.5-1,1.1-1S14.8,3.8,14.8,4.4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2e4a5a0b575d3ca8f61c211eaa03fb3b.svg";
export { ForwardRef as ReactComponent };